function disableAnimation(event) {
  const el = event.target;
  el.setAttribute('class', el.getAttribute('class').replace(' animation-spin', ''));
  el.removeEventListener('animationiteration', disableAnimation);
}

function enableAnimation(el) {
  el.setAttribute('class', `${el.getAttribute('class')} animation-spin`);
}

function setAnimation(el, value) {
  if (value) {
    enableAnimation(el);
  } else {
    el.addEventListener('animationiteration', disableAnimation);
  }
}

export default {
  bind(el, { value }) {
    setAnimation(el, value);
  },
  update(el, { value }) {
    setAnimation(el, value);
  },
};
